import { Typography } from "@mui/material"
import { ReactElement } from "react"

import {
    AppAccordion,
    AppAccordionDetails,
    AppAccordionSummary,
} from "../../dataDisplay/accordions/appAccordions"
import VerticalKeyValueList from "../../dataDisplay/verticalKeyValueList"

interface IDetailListAccordionProps {
    title: string
    kwargs: Record<string, string | number | boolean>
    defaultExpanded?: boolean
}

/**
 * Uncontrolled accordion component which displays a list of key value pairs.
 */
const DetailListAccordion = ({
    title,
    kwargs,
    defaultExpanded,
}: IDetailListAccordionProps): ReactElement => (
    <AppAccordion defaultExpanded={defaultExpanded}>
        <AppAccordionSummary>
            <Typography fontWeight="500">{title}</Typography>
        </AppAccordionSummary>
        <AppAccordionDetails>
            <VerticalKeyValueList kwargs={kwargs} />
        </AppAccordionDetails>
    </AppAccordion>
)
DetailListAccordion.defaultProps = {
    defaultExpanded: false,
}

export default DetailListAccordion
